<app-unauthorized-layout>
  <div class="login-container verify-email-container">
    <app-auth-left-panel  [imageSrc]="'assets/images/airport.png'"
    imageAlt="Airport" class="login-image"></app-auth-left-panel>

    <div class="login-form-section">
    <img src="assets/images/logo.png" alt="Civil Aviation Authority" class="login-logo" />

    <div class="verify-email-card">
      <!-- Loading Token Validation -->
      @if (isValidatingToken) {
        <div class="validating-state">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h4>{{ 'verification.validatingToken' | translate }}</h4>
          <p>{{ 'verification.pleasWait' | translate }}</p>
        </div>
      }

      <!-- Token Invalid or Expired -->
      @if (!isValidatingToken && !isTokenValid && !isAlreadyVerified && tokenMessage) {
        <div class="token-error-state">
          <div class="alert alert-danger alert-dismissible fade show" role="alert">
            <i class="bi bi-exclamation-triangle m-2"></i>
            <strong>{{ 'verification.verificationFailed' | translate }}</strong>
            <p class="mt-2">{{ tokenMessage }}</p>
          </div>
          <a href="/register" class="btn btn-outline-primary w-100">
            <i class="bi bi-arrow-left"></i> {{ 'verification.backToRegister' | translate }}
          </a>
        </div>
      }

      <!-- Already Verified -->
      @if (isAlreadyVerified) {
        <div class="already-verified-state">
          <div class="alert alert-success alert-dismissible fade show" role="alert">
            <i class="bi bi-check-circle m-2"></i>
            <strong>{{ 'verification.alreadyVerified' | translate }}</strong>
            <p class="mt-2">{{ tokenMessage }}</p>
          </div>
          <p class="text-muted text-center">{{ 'verification.redirectingToLogin' | translate }}</p>
        </div>
      }

      <!-- Verification Form -->
      @if (!isValidatingToken && isTokenValid && !isAlreadyVerified) {
        <div class="verification-form">
          <h3 class="text-center mb-4">{{ 'verification.enterVerificationDetails' | translate }}</h3>
          <!-- Success Message -->
          @if (successMessage) {
            <div class="alert alert-success alert-dismissible fade show" role="alert">
              <i class="bi bi-check-circle m-2"></i>
              <strong>{{ 'verification.success' | translate }}</strong>
              <p class="mt-2">{{ successMessage }}</p>
            </div>
          }
          <!-- Error Message -->
          @if (errorMessage) {
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
              <i class="bi bi-exclamation-triangle m-2"></i>
              <strong>{{ 'verification.error' | translate }}</strong>
              <p class="mt-2">{{ errorMessage }}</p>
              <button type="button" class="btn-close" (click)="errorMessage = null"></button>
            </div>
          }
          <!-- Info Message -->
          <div class="alert alert-info mb-4" role="alert">
            <i class="bi bi-info-circle m-2"></i>
            {{ 'verification.verificationInfo' | translate }}
            @if (otpExpiresAt) {
              <div class="mt-2">
                <small>{{ 'verification.expiresAt' | translate }}: {{ otpExpiresAt | date:'medium' }}</small>
              </div>
            }
          </div>
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <!-- Email Field -->
            <div class="mb-3">
              <label for="email" class="form-label">{{ 'verification.email' | translate }}</label>
              <input
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                placeholder="Enter your email"
                [class.is-invalid]="getFieldError('email') !== null">
                @if (getFieldError('email')) {
                  <div class="invalid-feedback">
                    {{ getFieldError('email') }}
                  </div>
                }
              </div>
              <!-- OTP Code Field -->
              <div class="mb-3">
                <label for="otpCode" class="form-label">{{ 'verification.otpCode' | translate }}</label>
                <input
                  type="text"
                  class="form-control form-control-lg otp-input"
                  id="otpCode"
                  formControlName="otpCode"
                  placeholder="000000"
                  maxlength="6"
                  inputmode="numeric"
                  [class.is-invalid]="getFieldError('otpCode') !== null">
                  @if (getFieldError('otpCode')) {
                    <div class="invalid-feedback">
                      {{ getFieldError('otpCode') }}
                    </div>
                  }
                </div>
                <!-- Submit Button -->
                <button
                  type="submit"
                  class="btn btn-primary w-100 btn-lg"
                  [disabled]="form.invalid || isLoading">
                  @if (!isLoading) {
                    <span>{{ 'verification.verify' | translate }}</span>
                  }
                  @if (isLoading) {
                    <span>
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ 'verification.verifying' | translate }}
                    </span>
                  }
                </button>
              </form>
              <!-- Back to Register Link -->
              <div class="text-center mt-3">
                <p class="text-muted">{{ 'verification.problemWithEmail' | translate }}</p>
                <a href="/register" class="btn btn-link">{{ 'verification.backToRegister' | translate }}</a>
              </div>
        </div>}
      </div>
  </div>
  </div>

</app-unauthorized-layout>